import React from 'react'
import Nav from '../Components/Navbar/Nav'
import Footer from '../Components/Footer/Footer'
import Contactus from '../Components/contactus/Contactus'

const ContactUsP = () => {
  return (
    <div>
      <Nav/>
      <Contactus/>
      <Footer/>
    </div>
  )
}

export default ContactUsP
